// Demo/localStorage layer for Enrollment Pipeline.

const STORE_KEY = "daycare.demo.enrollment.v1";
const ORG_ID = "00000000-0000-0000-0000-000000000001";
const SUNFLOWER = "00000000-0000-0000-0000-000000000101";
const WILLOW = "00000000-0000-0000-0000-000000000102";
const ACORN = "00000000-0000-0000-0000-000000000104";

function daysAgo(n) {
  return new Date(Date.now() - n * 24 * 60 * 60 * 1000).toISOString();
}

function seedInitial() {
  const records = [
    {
      id: "demo-enr-1",
      organization_id: ORG_ID,
      parent_first_name: "Arman",
      parent_last_name: "Saeed",
      parent_email: "arman.saeed@example.com",
      parent_phone: "+1 555-0109",
      child_first_name: "Zoya",
      child_last_name: "Saeed",
      child_date_of_birth: "2023-08-12",
      preferred_classroom_id: ACORN,
      preferred_age_group: "Infant (0–1)",
      preferred_start_date: "2026-09-01",
      parent_notes: "Looking for a warm and gentle environment for our first baby.",
      source: "website",
      stage: "inquiry",
      stage_changed_at: daysAgo(3),
      submitted_by_profile_id: null,
      linked_family_id: null,
      linked_child_id: null,
      created_at: daysAgo(3),
      updated_at: daysAgo(3),
      history: [{ from_stage: null, to_stage: "inquiry", changed_at: daysAgo(3) }],
    },
    {
      id: "demo-enr-2",
      organization_id: ORG_ID,
      parent_first_name: "Jane",
      parent_last_name: "Okafor",
      parent_email: "jane.okafor@example.com",
      parent_phone: "+1 555-0121",
      child_first_name: "Michael",
      child_last_name: "Okafor",
      child_date_of_birth: "2023-02-05",
      preferred_classroom_id: SUNFLOWER,
      preferred_age_group: "Toddler (2–3)",
      preferred_start_date: "2026-10-01",
      parent_notes: "Looking to transition Michael from home care around his 3rd birthday.",
      source: "referral",
      stage: "application_submitted",
      stage_changed_at: daysAgo(1),
      submitted_by_profile_id: null,
      linked_family_id: null,
      linked_child_id: null,
      created_at: daysAgo(8),
      updated_at: daysAgo(1),
      history: [
        { from_stage: null, to_stage: "inquiry", changed_at: daysAgo(8) },
        { from_stage: "inquiry", to_stage: "tour_scheduled", changed_at: daysAgo(6) },
        { from_stage: "tour_scheduled", to_stage: "tour_completed", changed_at: daysAgo(4) },
        { from_stage: "tour_completed", to_stage: "application_submitted", changed_at: daysAgo(1) },
      ],
    },
    {
      id: "demo-enr-3",
      organization_id: ORG_ID,
      parent_first_name: "Dana",
      parent_last_name: "Weiss",
      parent_email: "dana.weiss@example.com",
      parent_phone: "+1 555-0134",
      child_first_name: "Ben",
      child_last_name: "Weiss",
      child_date_of_birth: "2022-11-30",
      preferred_classroom_id: WILLOW,
      preferred_age_group: "Preschool (3–4)",
      preferred_start_date: "2026-09-15",
      parent_notes: "Ben loves art and music — would love to hear about your curriculum.",
      source: "google",
      stage: "waitlisted",
      stage_changed_at: daysAgo(5),
      submitted_by_profile_id: null,
      linked_family_id: null,
      linked_child_id: null,
      created_at: daysAgo(20),
      updated_at: daysAgo(5),
      history: [
        { from_stage: null, to_stage: "inquiry", changed_at: daysAgo(20) },
        { from_stage: "inquiry", to_stage: "tour_completed", changed_at: daysAgo(15) },
        { from_stage: "tour_completed", to_stage: "application_submitted", changed_at: daysAgo(10) },
        { from_stage: "application_submitted", to_stage: "waitlisted", changed_at: daysAgo(5) },
      ],
    },
    {
      id: "demo-enr-4",
      organization_id: ORG_ID,
      parent_first_name: "Sam",
      parent_last_name: "Kim",
      parent_email: "sam.kim@example.com",
      parent_phone: "+1 555-0155",
      child_first_name: "Iris",
      child_last_name: "Kim",
      child_date_of_birth: "2021-03-22",
      preferred_classroom_id: WILLOW,
      preferred_age_group: "Preschool (3–4)",
      preferred_start_date: "2026-09-01",
      parent_notes: "Relocating to the area in August. Excited to chat!",
      source: "walk_in",
      stage: "offer",
      stage_changed_at: daysAgo(2),
      submitted_by_profile_id: null,
      linked_family_id: null,
      linked_child_id: null,
      created_at: daysAgo(30),
      updated_at: daysAgo(2),
      history: [
        { from_stage: null, to_stage: "inquiry", changed_at: daysAgo(30) },
        { from_stage: "inquiry", to_stage: "application_submitted", changed_at: daysAgo(15) },
        { from_stage: "application_submitted", to_stage: "offer", changed_at: daysAgo(2) },
      ],
    },
    {
      id: "demo-enr-5",
      organization_id: ORG_ID,
      parent_first_name: "Rivka",
      parent_last_name: "Cohen",
      parent_email: "parent@daycare.test",
      parent_phone: "+1 555-0100",
      child_first_name: "Noa",
      child_last_name: "Cohen",
      child_date_of_birth: "2022-05-14",
      preferred_classroom_id: SUNFLOWER,
      preferred_age_group: "Toddler (2–3)",
      preferred_start_date: "2024-09-01",
      parent_notes: "",
      source: "referral",
      stage: "enrolled",
      stage_changed_at: daysAgo(200),
      submitted_by_profile_id: "demo-parent",
      linked_family_id: "00000000-0000-0000-0000-000000000201",
      linked_child_id: "00000000-0000-0000-0000-000000000301",
      created_at: daysAgo(280),
      updated_at: daysAgo(200),
      history: [
        { from_stage: null, to_stage: "inquiry", changed_at: daysAgo(280) },
        { from_stage: "inquiry", to_stage: "application_submitted", changed_at: daysAgo(260) },
        { from_stage: "application_submitted", to_stage: "offer", changed_at: daysAgo(230) },
        { from_stage: "offer", to_stage: "enrolled", changed_at: daysAgo(200) },
      ],
    },
  ];
  const notes = [
    {
      id: "demo-note-1",
      enrollment_id: "demo-enr-2",
      author_id: "demo-admin",
      body: "Parents seem very organized. Willing to start in Willow if Sunflower is full by Oct 1.",
      created_at: daysAgo(2),
    },
    {
      id: "demo-note-2",
      enrollment_id: "demo-enr-3",
      author_id: "demo-admin",
      body: "Waitlist priority #1 in Willow. Notify when a spot opens.",
      created_at: daysAgo(4),
    },
  ];
  return { records, notes };
}

function readStore() {
  try {
    const raw = localStorage.getItem(STORE_KEY);
    if (raw) return JSON.parse(raw);
  } catch {
    // fall through
  }
  const seeded = seedInitial();
  writeStore(seeded);
  return seeded;
}
function writeStore(s) {
  localStorage.setItem(STORE_KEY, JSON.stringify(s));
}

// ---- Public demo API ----

export function demoListRecords({ role, profileId, filters = {} } = {}) {
  const s = readStore();
  let rows = s.records;
  if (role === "parent") {
    rows = rows.filter((r) => r.submitted_by_profile_id === profileId);
  } else if (role === "teacher" || role === "cms_editor") {
    return [];
  }
  if (filters.stage)        rows = rows.filter((r) => r.stage === filters.stage);
  if (filters.classroomId)  rows = rows.filter((r) => r.preferred_classroom_id === filters.classroomId);
  if (filters.source)       rows = rows.filter((r) => r.source === filters.source);
  if (filters.search) {
    const q = filters.search.toLowerCase();
    rows = rows.filter(
      (r) =>
        (r.parent_first_name || "").toLowerCase().includes(q) ||
        (r.parent_last_name || "").toLowerCase().includes(q) ||
        (r.parent_email || "").toLowerCase().includes(q) ||
        (r.child_first_name || "").toLowerCase().includes(q) ||
        (r.child_last_name || "").toLowerCase().includes(q),
    );
  }
  return rows
    .slice()
    .sort((a, b) => (b.stage_changed_at || "").localeCompare(a.stage_changed_at || ""));
}

export function demoGetRecord(id) {
  const s = readStore();
  const record = s.records.find((r) => r.id === id);
  if (!record) return null;
  const notes = s.notes
    .filter((n) => n.enrollment_id === id)
    .sort((a, b) => b.created_at.localeCompare(a.created_at));
  return { ...record, notes };
}

export function demoCreateInquiry(payload) {
  const s = readStore();
  const now = new Date().toISOString();
  const row = {
    id: `demo-enr-${Date.now()}-${Math.random().toString(36).slice(2, 5)}`,
    organization_id: ORG_ID,
    parent_first_name: payload.parentFirstName,
    parent_last_name: payload.parentLastName || null,
    parent_email: payload.parentEmail,
    parent_phone: payload.parentPhone || null,
    child_first_name: payload.childFirstName || null,
    child_last_name: payload.childLastName || null,
    child_date_of_birth: payload.childDob || null,
    preferred_classroom_id: payload.preferredClassroomId || null,
    preferred_age_group: payload.preferredAgeGroup || null,
    preferred_start_date: payload.preferredStartDate || null,
    parent_notes: payload.parentNotes || null,
    source: payload.source || "website",
    stage: "inquiry",
    stage_changed_at: now,
    submitted_by_profile_id: payload.submittedBy || null,
    linked_family_id: null,
    linked_child_id: null,
    created_at: now,
    updated_at: now,
    history: [{ from_stage: null, to_stage: "inquiry", changed_at: now }],
  };
  s.records.push(row);
  writeStore(s);
  return row;
}

export function demoUpdateRecord(id, patch) {
  const s = readStore();
  const now = new Date().toISOString();
  s.records = s.records.map((r) => {
    if (r.id !== id) return r;
    const next = { ...r, ...patch, updated_at: now };
    if (patch.stage && patch.stage !== r.stage) {
      next.stage_changed_at = now;
      next.history = [
        ...(r.history || []),
        { from_stage: r.stage, to_stage: patch.stage, changed_at: now, changed_by: patch.changedBy },
      ];
    }
    return next;
  });
  writeStore(s);
  return s.records.find((r) => r.id === id);
}

export function demoAddNote({ enrollmentId, authorId, body }) {
  const s = readStore();
  const note = {
    id: `demo-note-${Date.now()}`,
    enrollment_id: enrollmentId,
    author_id: authorId,
    body,
    created_at: new Date().toISOString(),
  };
  s.notes.push(note);
  writeStore(s);
  return note;
}
